// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fq-0";
export var fileCarousel = "_fq-2";
export var removeFileButton = "_fq-1";